angular.module('impactx.scheduler').directive('ixSchedulerTask', function () {
    return {
        restrict: 'E',
        controller: 'SchedulerTaskCtrl',
        controllerAs: 'schedulerTaskCtrl',
        templateUrl: 'modules/scheduler/templates/scheduler-task.html',
        bindToController: {
            taskSelection: "=",
            task: "=",
            trns: "="
        }
    }
});